import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("F:/Github/dexon-technology/frontend/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("F:/Github/dexon-technology/frontend/layouts/default.vue").then(m => m.default || m))
}